var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBless(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "600pt",
    height: "600pt",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(83.898926%,64.698792%,16.099548%)",
      fillOpacity: 1
    },
    d: "M 300 584.347656 C 296.078125 584.347656 292.390625 582.820313 289.617188 580.046875 L 19.953125 310.382813 C 14.226563 304.65625 14.226563 295.34375 19.953125 289.617188 L 289.617188 19.953125 C 292.390625 17.179688 296.078125 15.652344 300 15.652344 C 303.921875 15.652344 307.609375 17.179688 310.382813 19.953125 L 580.046875 289.617188 C 582.820313 292.390625 584.347656 296.078125 584.347656 300 C 584.347656 303.921875 582.820313 307.609375 580.046875 310.382813 L 310.382813 580.046875 C 307.609375 582.820313 303.921875 584.347656 300 584.347656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 300 10.652344 C 294.964844 10.652344 289.925781 12.574219 286.082031 16.414063 L 16.417969 286.082031 C 8.730469 293.769531 8.730469 306.230469 16.417969 313.917969 L 286.082031 583.582031 C 289.925781 587.425781 294.964844 589.347656 300 589.347656 C 305.035156 589.347656 310.074219 587.425781 313.917969 583.582031 L 583.582031 313.917969 C 591.269531 306.230469 591.269531 293.769531 583.582031 286.082031 L 313.917969 16.414063 C 310.074219 12.574219 305.035156 10.652344 300 10.652344 M 300 20.652344 C 302.585938 20.652344 305.019531 21.660156 306.847656 23.488281 L 576.511719 293.152344 C 580.285156 296.929688 580.285156 303.070313 576.511719 306.84375 L 306.847656 576.511719 C 305.019531 578.339844 302.585938 579.347656 300 579.347656 C 297.414063 579.347656 294.984375 578.339844 293.152344 576.511719 L 23.488281 306.84375 C 19.714844 303.070313 19.714844 296.929688 23.488281 293.152344 L 293.152344 23.488281 C 294.984375 21.660156 297.414063 20.652344 300 20.652344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 299.015625 217.363281 L 334.828125 279.394531 L 370.644531 341.425781 L 227.390625 341.425781 L 263.203125 279.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 326.019531 158.394531 C 326.019531 173.308594 313.929688 185.394531 299.015625 185.394531 C 284.101563 185.394531 272.015625 173.308594 272.015625 158.394531 C 272.015625 143.480469 284.101563 131.390625 299.015625 131.390625 C 313.929688 131.390625 326.019531 143.480469 326.019531 158.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 402.925781 395.828125 C 390.316406 387.871094 386.542969 371.195313 394.503906 358.582031 C 402.464844 345.972656 419.140625 342.199219 431.75 350.160156 C 444.363281 358.121094 448.132813 374.796875 440.171875 387.40625 C 432.214844 400.019531 415.535156 403.789063 402.925781 395.828125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 167.664063 353.570313 C 180.0625 345.289063 196.832031 348.628906 205.117188 361.027344 C 213.398438 373.429688 210.058594 390.199219 197.660156 398.480469 C 185.257813 406.761719 168.488281 403.425781 160.203125 391.023438 C 151.921875 378.621094 155.261719 361.851563 167.664063 353.570313 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 160,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 4393.125 3016.875 C 4393.125 2242.03125 3764.960938 1613.90625 2990.15625 1613.90625 C 2215.3125 1613.90625 1587.226563 2242.03125 1587.226563 3016.875 C 1587.226563 3791.679688 2215.3125 4419.804688 2990.15625 4419.804688 C 3764.960938 4419.804688 4393.125 3791.679688 4393.125 3016.875 Z M 4393.125 3016.875 ",
    transform: "matrix(0.1,0,0,-0.1,0,600)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 160,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 3755.976563 3016.875 C 3755.976563 2593.90625 3413.125 2251.015625 2990.15625 2251.015625 C 2567.1875 2251.015625 2224.335938 2593.90625 2224.335938 3016.875 C 2224.335938 3439.804688 2567.1875 3782.695313 2990.15625 3782.695313 C 3413.125 3782.695313 3755.976563 3439.804688 3755.976563 3016.875 Z M 3755.976563 3016.875 ",
    transform: "matrix(0.1,0,0,-0.1,0,600)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBless);
export default __webpack_public_path__ + "static/media/Bless.36518e10c0893cfb4639ef6d42421b28.svg";
export { ForwardRef as ReactComponent };